var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    id: "image",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdc75b",
    d: "M479.34,347.59v40.87a30,30,0,0,1-30,30H62.66a30,30,0,0,1-30-30V255.33l148.67,83.31a51.314,51.314,0,0,0,57.59-5.17l70.25-58.65a51.287,51.287,0,0,1,61.66-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed664c",
    d: "M479.34,123.54V347.59l-108.51-75.4a51.287,51.287,0,0,0-61.66,2.63l-70.25,58.65a51.314,51.314,0,0,1-57.59,5.17L32.66,255.33V123.54a30,30,0,0,1,30-30H449.34A30,30,0,0,1,479.34,123.54ZM244.56,196.83c0-29.17-24.74-52.82-55.25-52.82s-55.26,23.65-55.26,52.82,24.74,52.82,55.26,52.82S244.56,226,244.56,196.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdc75b",
    d: "M189.31,144.01c30.51,0,55.25,23.65,55.25,52.82s-24.74,52.82-55.25,52.82S134.05,226,134.05,196.83,158.79,144.01,189.31,144.01Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M490,124a40,40,0,0,0-40-40H63a40,40,0,0,0-40,40V389a40,40,0,0,0,40,40H450a40,40,0,0,0,40-40ZM62.66,104H449.34A19.346,19.346,0,0,1,469,123.54V328.464l-92.669-64.511a61.459,61.459,0,0,0-73.655,3.191l-70.147,58.6a40.773,40.773,0,0,1-46.162,4.173L43,249.471V123.54A19.346,19.346,0,0,1,62.66,104ZM43,388.46V272.4l133.627,74.976a60.862,60.862,0,0,0,68.787-6.227l70.15-58.6a41.175,41.175,0,0,1,49.411-2.142L469,352.818V388.46A19.346,19.346,0,0,1,449.34,408H62.66A19.346,19.346,0,0,1,43,388.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.31,259.65c35.979,0,65.25-28.181,65.25-62.82s-29.271-62.82-65.25-62.82-65.26,28.181-65.26,62.82S153.325,259.65,189.31,259.65Zm0-105.64c24.951,0,45.25,19.209,45.25,42.82s-20.3,42.82-45.25,42.82-45.26-19.209-45.26-42.82S164.354,154.01,189.31,154.01Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/ErrorImage.d38c74b040967b400ee97ab2ae656067.svg";
export { ForwardRef as ReactComponent };